module.exports = __webpack_public_path__ + "static/media/DSHARE.27e9dda3.png";